export default __webpack_public_path__ + "static/media/Slide28.658ce739.JPG";